import React from "react";
import AdminHeader from "../../Share/AdminHeader";
import AdminVerticalmenu from "../../Share/AdminVerticalMenu";
import { Outlet } from "react-router-dom";
import clsx from "clsx";
import Styles from "./AdminPage.module.scss";
import { StoreHook, Actions } from "../../Store";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { ISCLOSED } from "../../Store/Values";
function AdminPage() {
  const [state, dispatch] = StoreHook();
  const { adminOpenOrCloseverticalMenu } = state;
  const handle = useFullScreenHandle();

  const handleFullScreen = () => {
    if (!handle.active) {
      handle.enter();
    } else {
      handle.exit();
    }
  };

  const handleCloseChildVerticalmenu = () => {
    dispatch(Actions.updateAdminOpenOrCloseVerticalMenuChild(ISCLOSED));
  };

  return (
    <div style={{ backgroundColor: "#f8f8f8", display: "block" }}>
      <FullScreen handle={handle}>
        <AdminHeader handleFullScreen={handleFullScreen} />

        <AdminVerticalmenu />
        <div
          onClick={() => handleCloseChildVerticalmenu()}
          className={clsx(
            Styles.outlet,
            adminOpenOrCloseverticalMenu ? Styles.active : ""
          )}
        >
          <div className={clsx(Styles.outletWrap)}>
            <Outlet />
          </div>
        </div>
      </FullScreen>
    </div>
  );
}

export default AdminPage;
